import Call from '../Call';
import {objToQs} from '../Utils';

const PushapiCpc = {
    get(filters) {
        return Call(`pushapiCpc/all?${objToQs(filters)}`);
    },

    getReport(filters) {
        return Call(`pushapiCpc?${objToQs(filters)}`);
    },
};

export default PushapiCpc;


// WEBPACK FOOTER //
// ./src/services/API/components/PushapiCpc.js